import { AgingIntervalType } from '../enums.js'

/** The default aging type for all new contracts */
export const DEFAULT_AGING_INTERVAL_TYPE = AgingIntervalType.BILLING_END
